import type { RecruitmentReportingQuery } from '../api/recruitmentReportingApi';

const REPORTING_TIME_ZONE = 'Europe/Amsterdam';

export function amsterdamDate(value: Date): string {
    const parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: REPORTING_TIME_ZONE,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).formatToParts(value);
    const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((item) => item.type === type)?.value ?? '';
    return `${part('year')}-${part('month')}-${part('day')}`;
}

export function defaultRecruitmentReportingQuery(now = new Date()): RecruitmentReportingQuery {
    const to = amsterdamDate(now);
    const [year, month, day] = to.split('-').map(Number);
    const targetMonthIndex = year * 12 + (month - 1) - 6;
    const targetYear = Math.floor(targetMonthIndex / 12);
    const targetMonth = targetMonthIndex - targetYear * 12;
    const lastTargetDay = new Date(Date.UTC(targetYear, targetMonth + 1, 0)).getUTCDate();
    const from = new Date(Date.UTC(targetYear, targetMonth, Math.min(day, lastTargetDay))).toISOString().slice(0, 10);
    return { from, to, bucket: 'month' };
}
